import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCheck = () => {
  return (
    <g>
      <path d="m6.4372 13.125a.7475.7475 0 0 1 -.53-.22l-5.6247-5.6242a.75.75 0 0 1 1.0605-1.0608l5.0942 5.0942 8.22-8.22a.75.75 0 0 1 1.0605 1.0605l-8.75 8.75a.7476.7476 0 0 1 -.5305.2203z" />
    </g>
  );
};

export default withIcon(IconCheck);
